import { ErrorBoundary } from '@components/ErrorBoundary/ErrorBoundary';
import { componentRegistry, resolveRequestedComponent } from '@components/componentRegistry';
import { config, environment } from '@config/environment.config';
import { configureSecuritySettings, logSecurityConfig } from '@utils/security.utils';
import { ToastProvider } from '@/context/ToastContext';
import './App.css';

configureSecuritySettings({
  allowedOrigins: config.allowedOrigins,
  isDevelopment: config.isDevelopment,
  maxFileSizeMB: config.maxFileSizeMB,
});

// Log security configuration in development
logSecurityConfig();

function App() {
  const searchParams = new URLSearchParams(window.location.search);
  const requestedComponent = searchParams.get('component') || searchParams.get('componentType');
  const selectedComponentType = resolveRequestedComponent(
    requestedComponent,
    environment.getEnabledComponents()
  );
  const SelectedComponent = componentRegistry[selectedComponentType] ?? componentRegistry.textEditor;

  return (
    <ErrorBoundary>
      <ToastProvider>
        <div className="App">
          {SelectedComponent ? <SelectedComponent /> : null}
        </div>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
